<template>
	<div class="main">
		<header class="page-title">
			<h2>Edit Category - {{ categoryData.title }}</h2>
			<div class="ml-auto">
				<a @click="saveCategory" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>
		<div class="card">
			<header class="card-header language-list">
				<h3 class="card-title">Properties</h3>
				<lang-selector></lang-selector>
			</header>
			<div class="card-body">
				<div class="flex box start">
					<div class="form-group six-lg">
						<label class="form-group-label" for="name">Name</label>
						<input id="name" name="name" type="text" v-model="categoryData[clickedLang].title">
						<p class="input-error" v-if="errors.errors[errorTitleCurrentLanguage]">{{ errors.errors[errorTitleCurrentLanguage] }}</p>
					</div>
					<div class="form-group six-lg">
						<label class="form-group-label" for="slug">Slug</label>
						<input id="slug" name="slug" type="text" v-model="categoryData[clickedLang].slug">
						<p class="input-error" v-if="errors.errors[errorSlugCurrentLanguage]">{{ errors.errors[errorSlugCurrentLanguage] }}</p>
					</div>
					<div class="form-group twelve-lg">
						<label class="label-checkbox">
							<input type="checkbox" v-model="categoryData.is_hidden">
							<span>Hidden Category</span>
						</label>
					</div>
				</div>
			</div>
		</div>
		<meta-tags-card
				:data-card-instance-id="categoryData.id"
				:data-card-meta-seo-box="categoryData.seoBox">
		</meta-tags-card>
	</div>
</template>

<script>
import Errors from '../../Utils/Errors.js'
import {eventBus} from '../../app'

export default {
	props: {
		dataCategoryData: {
			required: false,
			type: Object
		}
	},
	data() {
		return {
			categoryData: this.dataCategoryData,

			clickedLang: this.$defaultLanguage.locale,
			errors: new Errors(),
		}
	},
	created() {
		let vm = this;

		for (let i = 0; i < vm.$availableLanguages.length; i++) {
			if (vm.categoryData.translations[vm.$availableLanguages[i].locale]) {
				vm.categoryData[vm.$availableLanguages[i].locale] = {
					title: vm.categoryData.translations[vm.$availableLanguages[i].locale].title,
					slug: vm.categoryData.translations[vm.$availableLanguages[i].locale].slug,
				}
			} else {
				vm.categoryData[vm.$availableLanguages[i].locale] = {
					title: null,
					slug: null
				};
			}
		}

		// When setActiveStatus method ran, change selected data in form fields
		/* From LangSelector */
		eventBus.$on('setActiveStatus', function (clickedLang) {
			vm.clickedLang = clickedLang;

			eventBus.$emit('pushActiveStatus', {locale: clickedLang});
		});

		/* From MetaTagsCard */
		eventBus.$on('updateMetaTags', function (currentMetas) {
			axios.post('/api/' + vm.$selectedSite.slug + '/categories/' + vm.categoryData.id + '/seo', currentMetas)
					.then(function (response) {
						vm.$toastr.success('Category SEO updated.');
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						vm.$toastr.error('Save category SEO changes failed.', 'Error');
					});
		})
	},
	methods: {
		saveCategory: function () {
			let vm = this;

			axios.put('/api/' + vm.$selectedSite.slug + '/categories/' + vm.categoryData.id, vm.categoryData)
					.then(function (response) {
						vm.$toastr.success('Category updated.');
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						vm.$toastr.error('Save category changes failed.', 'Error');
					});
		},
	},
	computed: {
		errorTitleCurrentLanguage: function () {
			return this.clickedLang + '_title';
		},
		errorSlugCurrentLanguage: function () {
			return this.clickedLang + '_slug';
		},
	}
}
</script>

<style scoped>

</style>
